import { Offer } from '../types/Offer'
import { SOffer } from '../types/api/Offer'

export const offerTransformer = (data: SOffer): Offer => {
  return {
    id: data.documentId ?? (data.id != null ? String(data.id) : ''),
    ...data,
  } as unknown as Offer
}
